import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  actions: { display: 'flex', gap: theme.spacing(1), flexWrap: 'wrap', alignItems: 'center' },
  prompt: {
    width: '100%',
    minHeight: 360,
    border: '1px solid #d1d5db',
    borderRadius: 6,
    padding: theme.spacing(1.25),
    fontFamily: 'monospace',
    fontSize: 12,
    color: '#111827',
    backgroundColor: '#f9fafb',
    boxSizing: 'border-box',
    whiteSpace: 'pre-wrap',
  },
  muted: { color: '#6b7280', fontSize: 12 },
}));

const ActionCognitivePrompt = ({
  boutonLibelle,
  description,
  libelleCopie,
  messageCopieSucces,
  prompt,
  titre,
  ouvert,
  setOuvert,
}) => {
  const classes = useStyles();
  const [messageCopie, setMessageCopie] = useState('');

  const copierPrompt = () => copierTexte(prompt)
    .then(() => setMessageCopie(messageCopieSucces || 'Prompt copie.'))
    .catch(() => setMessageCopie('Copie automatique impossible. Le texte peut etre selectionne ci-dessous.'));

  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<FileCopyIcon />}
        onClick={() => {
          setMessageCopie('');
          setOuvert(true);
        }}
        disabled={!prompt}
      >
        {boutonLibelle || 'Creer une branche depuis cette conversation'}
      </Button>
      <Dialog open={ouvert} onClose={() => setOuvert(false)} maxWidth="md" fullWidth>
        <DialogTitle>{titre || 'Creer une branche depuis cette conversation'}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" className={classes.muted} style={{ marginBottom: 12 }}>
            {description || "Copiez ce prompt dans la conversation ChatGPT ou le travail a eu lieu. ChatGPT produira ensuite le prompt Codex complet pour l'admission SyncStats System."}
          </Typography>
          <div className={classes.actions} style={{ marginBottom: 8 }}>
            <Button variant="contained" color="primary" size="small" startIcon={<FileCopyIcon />} onClick={copierPrompt}>
              {libelleCopie || 'Copier le prompt'}
            </Button>
            {messageCopie && <Typography variant="body2" className={classes.muted}>{messageCopie}</Typography>}
          </div>
          <textarea className={classes.prompt} readOnly value={prompt} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOuvert(false)} color="primary">Fermer</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export function copierTexte(texte) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(texte);
  }

  return new Promise((resolve, reject) => {
    try {
      const zone = document.createElement('textarea');
      zone.value = texte;
      zone.setAttribute('readonly', '');
      zone.style.position = 'fixed';
      zone.style.left = '-9999px';
      document.body.appendChild(zone);
      zone.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(zone);
      ok ? resolve() : reject(new Error('copy_failed'));
    } catch (err) {
      reject(err);
    }
  });
}

export default ActionCognitivePrompt;



// WEBPACK FOOTER //
// src/components/cockpit/ActionCognitivePrompt.js